import type {
  CoreClientChannelsPostsComplainParams,
  CoreClientChannelsPostsCreateParams,
  CoreClientChannelsPostsDeleteParams,
  CoreClientChannelsPostsPinParams,
  CoreClientChannelsPostsReadParams,
  CoreClientChannelsPostsUpdateParams,
} from '../../types/core/methods';
import type {PostApiModel} from './types';

import {EntityStore} from '../../utils/entityStore';

export class PostStore<
  T extends PostApiModel = PostApiModel,
> extends EntityStore<
  T,
  CoreClientChannelsPostsReadParams,
  CoreClientChannelsPostsCreateParams,
  Omit<CoreClientChannelsPostsUpdateParams, 'channel_id'>,
  Omit<CoreClientChannelsPostsDeleteParams, 'channel_id'>
> {
  complain = this._createMethod<
    Omit<CoreClientChannelsPostsComplainParams, 'channel_id'>
  >({
    method: 'client.channels.posts.complain',
  });
  pin = this._createMethod<Omit<CoreClientChannelsPostsPinParams, 'is_pinned'>>(
    {
      // @ts-expect-error: TODO: describe why
      applyParams: post => ({
        is_pinned: !post.is_pinned,
      }),
      method: 'client.channels.posts.pin',
    },
  );
}

export const postStore = new PostStore(
  'post',
  {
    create: 'client.channels.posts.create',
    delete: 'client.channels.posts.delete',
    fetch: 'client.channels.posts.read',
    update: 'client.channels.posts.update',
  },
  {
    applyParams: post => ({
      channel_id: post.channel_id,
    }),
  },
);
